import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Hand, MousePointer2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FlowToolbarDivider } from "./FlowToolbar";
import { ToolbarButton } from "./ToolbarButton";
export function CursorModeToggle({ value, onChange, hideDivider }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ToolbarButton, {
                onClick: ()=>onChange("pan"),
                active: value === "pan",
                tooltip: t("flowKit.toolbar.handTool"),
                children: /*#__PURE__*/ _jsx(Hand, {
                    className: "h-4 w-4"
                })
            }),
            /*#__PURE__*/ _jsx(ToolbarButton, {
                onClick: ()=>onChange("select"),
                active: value === "select",
                tooltip: t("flowKit.toolbar.selectTool"),
                children: /*#__PURE__*/ _jsx(MousePointer2, {
                    className: "h-4 w-4"
                })
            }),
            !hideDivider && /*#__PURE__*/ _jsx(FlowToolbarDivider, {})
        ]
    });
}

//# sourceMappingURL=CursorModeToggle.js.map